import { X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL || "https://calendly.com/eranmh-coach/30min";

const CalendlyModal = ({ isOpen, onClose }) => {
  const { language } = useLanguage();

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}
      onClick={onClose}
      data-testid="calendly-modal-overlay"
    >
      <div 
        className="relative w-full max-w-xl mx-4 bg-white rounded-2xl overflow-hidden shadow-2xl"
        style={{ height: '80vh', maxHeight: '700px' }}
        onClick={e => e.stopPropagation()}
        data-testid="calendly-modal"
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
          <p className="text-sm font-medium text-gray-600">
            {language === 'he' ? 'קביעת שיחת היכרות' : 'Schedule an Intro Call'}
          </p>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            data-testid="calendly-modal-close"
          >
            <X size={18} className="text-gray-500" />
          </button>
        </div>

        {/* Calendly iframe */}
        <iframe
          src={CALENDLY_URL}
          title="Calendly Scheduling"
          className="w-full border-0"
          style={{ height: 'calc(100% - 48px)' }}
          data-testid="calendly-iframe"
        />
      </div>
    </div>
  );
};

export default CalendlyModal;
